module.exports = __webpack_public_path__ + "img/personal-accident-insurance.db23c97.png";